import { Navigate } from 'react-router-dom';

import { ANY_SPORT_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { MarketHomePage } from '@sorare/marketplace/src/components/market-home/MarketHomePage';

const MarketHome = () => {
  const {
    flags: { useMarketHomePage = false },
  } = useFeatureFlags();
  const { sport, generateSportContextPath } = useSportContext();

  if (!useMarketHomePage)
    return <Navigate to={generateSportContextPath(ANY_SPORT_MARKET)} replace />;

  return <MarketHomePage sport={sport} />;
};

export default MarketHome;
